var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distribution-staus"},[_c('span',{class:_vm.typeName().className}),_vm._v(" "+_vm._s(_vm.typeName().name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }